import { render, staticRenderFns } from "./UserSettingsSignature.vue?vue&type=template&id=27687717"
import script from "./UserSettingsSignature.vue?vue&type=script&lang=js"
export * from "./UserSettingsSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports